import * as React from 'react';
import { TimePicker } from '@mui/x-date-pickers-pro';
import Typography from '@mui/material/Typography';
import { format, setHours, setMinutes } from 'date-fns';
import { useTheme } from '@mui/material';

type Props = {
  onChange: (value: Date) => void;
  closeModal: any;
  selectedDay: Date;
};

export default function CustomTime({
  onChange,
  closeModal,
  selectedDay,
}: Props) {
  const theme = useTheme();
  const [showCustomTime, setShowCustomTime] = React.useState(false);
  const [startTime, setStartTime] = React.useState<Date>();

  function clickHandle(datetime: Date) {
    // Extract hours and minutes from datetime
    const hours = datetime.getHours();
    const minutes = datetime.getMinutes();

    // Set the extracted time to the dayDate
    const combinedDateTime = setMinutes(setHours(selectedDay, hours), minutes);

    onChange(combinedDateTime);
    closeModal();
  }

  return (
    <>
      {!showCustomTime && (
        <div
          role="presentation"
          className="time-item"
          onClick={() => {
            setShowCustomTime(true);
            setStartTime(undefined);
          }}
          style={{
            borderWidth: 1,
            borderColor: theme.palette.primary.main,
            borderRadius: 5,
            padding: 10,
            alignItems: 'center',
            marginBottom: 10,
            backgroundColor: startTime ? theme.palette.primary.main : '#ffffff',
          }}>
          <Typography
            variant="h3"
            style={{
              color: startTime ? '#ffffff' : theme.palette.primary.main,
            }}>
            {startTime ? format(startTime, 'h:mma') : 'Custom time'}
          </Typography>
        </div>
      )}

      {showCustomTime && (
        <TimePicker
          onAccept={(value: Date | null) => {
            if (value) {
              setStartTime(value);
              setShowCustomTime(false);
              clickHandle(value);
            }
          }}
        />
      )}
    </>
  );
}
